import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import GDPRConsent from './GDPRConsent';

interface GDPRConsentDialogProps {
  open: boolean;
  onConsent: () => void;
  isLoading?: boolean;
}

const GDPRConsentDialog: React.FC<GDPRConsentDialogProps> = ({ 
  open, 
  onConsent, 
  isLoading = false 
}) => {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader className="sr-only">
          <DialogTitle>GDPR Samtycke</DialogTitle>
          <DialogDescription>
            Godkänn behandling av personuppgifter för att fortsätta.
          </DialogDescription>
        </DialogHeader>
        <GDPRConsent onConsent={onConsent} isLoading={isLoading} />
      </DialogContent>
    </Dialog>
  );
};

export default GDPRConsentDialog;